<template>
  <div class="merge-gz">
    <Modal
      v-model="modal"
      title="合并工资批量设置"
      :width="700"
      :footer-hide="true"
      :closable="false"
    >
      <p style="margin-bottom: 16px">
        ①合计工资设置适用于批量设置本次教师考勤确认单的所有教师的合计工资为<strong>指定的某个金额</strong>，系统
        将根据设置的固定值（<strong style="color: red"
          >仅对待确认的考勤单有效</strong
        >），自动的进行补发/补扣，并备注为：平台合计工资
        批量设置。设置后，该操作不可恢复，请操作前仔细核对！
      </p>
      <div style="margin-bottom: 16px">
        合计工资批量设置为:
        <InputNumber
          :max="5000"
          :min="0"
          v-model="moneyVal"
          placeholder="请输入金额，不得大于5000"
          style="width: 200px"
        ></InputNumber>
      </div>
      <RemarkCard>
        <h2>示例：</h2>
        <p>
          教师A用户，本月合计工资为：1000.00元，超过800元，多出的200需要缴纳一定的个税；
        </p>
        <p>
          教师B用户，本月合计工资为：1500.00元，超过800元，多出的700需要缴纳一定的个税；
        </p>
        <p>
          <strong>通过合计工资批量设置</strong
          >，可将教师A、教师B本月的合计工资，调整至800元，多出的200元、700元将通过补扣的方式扣除，可在其他月份给教师进行发放。若少于800元，将进行补发的方式补发。
        </p>
      </RemarkCard>
      <div class="modal-430-bottom" style="padding-top: 16px">
        <Button @click="handleCancle">取消</Button>
        <Button type="primary" @click="handleSubmit">确定</Button>
      </div>
    </Modal>
    <SendSms ref="sendSmsRef" @on-finish="onSendSmsFinish"> </SendSms>
  </div>
</template>

<script>
import RemarkCard from '@c/Base/RemarkCard.vue';
import SendSms from '@/components/Base/SendSms.vue'
import financeCenterApi from '@/request/financeCenter/index.js'

export default {
  components: {
    RemarkCard,
    SendSms
  },
  props: {
    sheetId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modal: false,
      moneyVal: 0,
      phoneCode: '',
      credential: ''
    }
  },
  methods: {
    handleShow() {
      this.moneyVal = 0
      this.modal = true
    },
    handleCancle() {
      this.modal = false
    },
    handleSubmit() {

      this.$refs.sendSmsRef.handleShow()
    },
    onSendSmsFinish(info) {
      this.phoneCode = info.phoneCode
      this.credential = info.credential
      this.setBatchSupplemental()
    },
    async setBatchSupplemental() {
      let res = await financeCenterApi.setBatchSupplementalApi({
        sheetId: this.sheetId,
        totalAmt: this.moneyVal * 100,
        credential: this.credential,
        verifyCode: this.phoneCode,
        supplementalMsg: '批量操作'
      })
      if (res.status == 200) {
        this.$refs.sendSmsRef.handleHide()
        this.$emit('on-finish')
        this.$Modal.success({
          title: '温馨提示',
          content: '合计工资批量设置成功！'
        });
        this.modal = false
      }
    }
  }
}
</script>

<style>
</style>